export const FreeReducedLunchFields = [
  { name: "Free Lunch Students", field: "free" },
  { name: "Reduced Lunch Students", field: "reduced" },
  { name: "Free or Reduced Lunch Students", field: "total", dashStyle: 'ShortDot', color: 'rgb(22, 91, 157)', marker: { radius: 2 } }
] 